import { Breadcrumb, IBreadcrumbItem } from "@coherence-design-system/controls";
import { useNavigate } from "react-router";

export default function AnnouncementBreadCrumb() {
  const navigate = useNavigate();
  const items: IBreadcrumbItem[] = [
    {
      text: "Home",
      key: "",
      href: "",
      onClick: () => navigate("/")
    } as IBreadcrumbItem,
    { text: "Announcements", key: "announcement", isCurrentItem: true }
  ];

  return (
    <Breadcrumb
      items={items}
      ariaLabel=""
      overflowAriaLabel="More links"
      styles={{
        itemLink: {
          selectors: { ":hover": { textDecoration: "underline" } }
        }
      }}
    />
  );
}
